import { LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponents = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 2,
        rows: 1,
        colsSize: [2.5, 1.5],
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/01/25/principle/propag-30m-greater-left.svg`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/01/25/principle/propag-30m-greater-right.svg`,
                  },
                },
                styles: {
                  paddingTop: "5%",
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
